import styled, { css } from 'styled-components';

const Row = styled.div.attrs(({ className }) => ({
  className: `row ${className || ''}`,
}))`
  padding: 0 1.25rem;
  > div {
    ${props =>
      props.noPadding &&
      css`
        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
        }
      `}
  }
`;

export default Row;
